<template>
  <div>
    <div class="file-box"  v-if="!uploaded">
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :action="imgHost + '/user/upload'"
        :headers="uploadHeader"
        :on-preview="handlePreview"
        :data="uploadData"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        auto-upload
        :on-success="uploadSuccess"
        :before-upload="beforeAvatarUpload"
        accept=".ppt,.pptx"
      > 
        <el-button size="small" type="primary">点击上传</el-button>
        <template #tip>
          <div class="el-upload__tip">只能上传PowerPoint文件</div>
        </template>
      </el-upload>
      <div class="team-button-box">
        <el-button class="next" @click="next" size="small" type="primary">提交</el-button>
      </div>
      <div class="bg-box">
        <img src="../../assets/images/team/bg.png" alt="" />
      </div>
    </div>
    <div class="status-box" v-else>
      <div class="img-box">
        <img src="../../assets/images/team/submit.png" alt="" />
        <p>ppt已提交成功</p>
        <!-- <el-button class="next" @click="next">下一步</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiSetProcess,
  apiGetProcess
}from '../../plugins/apis'
export default {
  data() {
    return {
      imgHost:process.env.VUE_APP_API_URL,
      uploadHeader:{ Authorization: window.localStorage.app_token },
      uploadData:{},
      fileList:[],
      uploaded:false
    };
  },
  async mounted(){
    this.uploadData = {
      file_source:1
    }
    await this.getView()
  },
  props:['round','label'],
  watch:{
    'label'(){
      this.getView()
    }
  },
  methods: {
    async getView(){
      let res = await apiGetProcess(this.round.round_id,this.label)
      if(res.code === 200){
        this.uploaded = res.data ? true:false
      }
    },
    async next(){
      if(this.processData.file_id === undefined || this.processData.file_id === '' || !this.processData.file_id){
        this.$message.error('请上传文件')
        return
      }
      let r = await apiSetProcess(this.round.round_id,this.label,this.processData)
      if(r.code === 500){
        this.$message.error(r.message)
        return
      }
      await this.getView()
      this.$Bus.$emit('reload_NowProcess');
    },
    beforeAvatarUpload(file) { 
      let fileArr = file.name.split('.')
      let bul = ['ppt','pptx'].indexOf(fileArr.pop()) > -1
      if(bul) {
        return true;
      }else{
        this.$message.error('只能上传ppt文件')
        return false
      }
    },
    uploadSuccess(e){
      if(e.code === 200){
        this.$message.success('上传成功')
        this.processData = {
          file_id:e.data.file_id,
        }
      }else[
        this.$message.error('上传失败')
      ]
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed() {
      this.fileList = []
      this.$refs.uploadFile.submit()
    }
  },
};
</script>

<style>
</style>